// src/lib/amplify-config.ts
"use client";

import { Amplify } from 'aws-amplify';
// FEATURE-129: habilita el listener que completa el flujo OAuth (signInWithRedirect)
// al volver con ?code=. En Amplify v6 NO se adjunta solo salvo que uses el componente
// Authenticator de Amplify UI; como tenemos AuthContext propio, hay que importarlo
// explícitamente (side-effect) o el token exchange nunca ocurre.
import 'aws-amplify/auth/enable-oauth-listener';

let isConfigured = false;

/**
 * Configura Amplify Auth para trabajar con Cognito User Pool.
 * CRÍTICO: ssr: false es requerido para static export de Next.js.
 * Esta función es idempotente - puede llamarse múltiples veces sin efectos secundarios.
 */
export function configureAmplify(): void {
  if (isConfigured) return;

  const userPoolId = process.env.NEXT_PUBLIC_COGNITO_USER_POOL_ID;
  const userPoolClientId = process.env.NEXT_PUBLIC_COGNITO_CLIENT_ID;

  if (!userPoolId || !userPoolClientId) {
    console.warn(
      'Amplify Auth: Missing NEXT_PUBLIC_COGNITO_USER_POOL_ID or NEXT_PUBLIC_COGNITO_CLIENT_ID'
    );
    return;
  }

  // FEATURE-129: OAuth (Google) via Hosted UI + PKCE.
  // Bloque condicional: si faltan las env vars, se omite y el login
  // email/password sigue funcionando igual (no rompe).
  const oauthDomain = process.env.NEXT_PUBLIC_COGNITO_DOMAIN;
  const redirectSignIn = process.env.NEXT_PUBLIC_OAUTH_REDIRECT_SIGNIN;
  const redirectSignOut = process.env.NEXT_PUBLIC_OAUTH_REDIRECT_SIGNOUT;
  const oauthConfig =
    oauthDomain && redirectSignIn && redirectSignOut
      ? {
          oauth: {
            domain: oauthDomain,
            scopes: ['openid', 'email', 'profile'],
            redirectSignIn: [redirectSignIn],
            redirectSignOut: [redirectSignOut],
            responseType: 'code' as const, // PKCE
          },
        }
      : {};

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId,
        loginWith: {
          username: true,
          email: true,
          ...oauthConfig,
        },
      },
    },
  }, { ssr: false }); // CRÍTICO: ssr: false para static export

  isConfigured = true;
}
